import React from "react";
import "./styles.scss";

const Loading = () => {
  return <span className="loader"></span>;
};

export default Loading;
